module.exports = __webpack_public_path__ + "img/icon-shield-menu-covid.d6e22348.svg";